import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function WebHookIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "14.5"}
      height={height || "13.523"}
      viewBox="0 0 14.5 13.523"
    >
      <path
        id="webhook"
        d="M10.163,4A3.241,3.241,0,0,0,8.24,9.86L6.632,12.516l-.041-.01a1.31,1.31,0,1,0,.794.61,1.358,1.358,0,0,0-.2-.254l1.77-2.91.173-.285L8.84,9.5a2.606,2.606,0,1,1,3.927-2.248,2.554,2.554,0,0,1-.112.763l.621.193a3.217,3.217,0,0,0,.142-.956A3.26,3.26,0,0,0,10.163,4Zm0,1.953a1.3,1.3,0,1,0,.315,2.564l1.567,2.839.153.285.295-.153a2.568,2.568,0,0,1,1.252-.326,2.6,2.6,0,1,1-1.811,4.477l-.448.468a3.254,3.254,0,1,0,2.259-5.6,3.2,3.2,0,0,0-1.262.285L11.048,8.2a1.3,1.3,0,0,0-.885-2.248Zm-4.7,4.65a3.254,3.254,0,1,0,3.989,3.49h3.042a1.3,1.3,0,1,0,0-.651H8.86v.326a2.6,2.6,0,1,1-3.235-2.523Z"
        transform="translate(-2.75 -3.75)"
        fill="#2f2f2f"
        stroke="#2f2f2f"
        stroke-width="0.5"
      />
    </svg>
  );
}
